import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { StatCard } from "components/common";
import NumberUtils from "util/NumberUtils";
const PlateGrid = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${theme.spacings.md};
  `
);
const formatNumber = (value) => NumberUtils.formatNumber(value);
const formatTokenShare = (part, total) => NumberUtils.formatPercentage(total > 0 ? part / total : 0);
const UsagePlateStats = ({ summary }) => {
  const { t } = useTranslation("enterprise_ai");
  return /* @__PURE__ */ React.createElement(PlateGrid, null, /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "primary",
      label: t("usage_stats.total_tokens"),
      value: formatNumber(summary.total_tokens),
      subValue: t("usage_plate_stats.total_reported")
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "info",
      label: t("usage_stats.input_tokens"),
      value: formatNumber(summary.input_tokens),
      subValue: i18n.t("usage_stats.of_total", {
        ns: "enterprise_ai",
        share: formatTokenShare(summary.input_tokens, summary.total_tokens)
      })
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "success",
      label: t("usage_stats.output_tokens"),
      value: formatNumber(summary.output_tokens),
      subValue: i18n.t("usage_stats.of_total", {
        ns: "enterprise_ai",
        share: formatTokenShare(summary.output_tokens, summary.total_tokens)
      })
    }
  ));
};
export default UsagePlateStats;
